import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderServices {
  
  apiCount:number = 0;
  showLoader:boolean = false;
  // isLoading = new Subject<boolean>();
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  show() {
    this.apiCount++;
    this.showLoader = true;
    this.isLoading.next(this.showLoader);
  }
  hide() {
    this.apiCount--;
    if(this.apiCount==0){
      this.showLoader = false;
      this.isLoading.next(this.showLoader);
    }
  }
}
